<template>
  <CustomModal v-if="!!template" @close="$emit('close')" :position="position" centered>
    <template v-slot:body>
      <div class="bg-block rounded -m-8 -m-12 grid grid-cols-12 planned-transaction-edit-modal">
        <div class="col-span-3
                    p-8 lg:p-12 lg:pb-6 lg:pl-14
                    bg-transaction-gradient">
          <div class="text-xl font-bold text-text leading-tight ">
            {{ $t('editTitle') }}
          </div>
        </div>
        <div class="col-span-9 pt-8 pl-8 pr-8 lg:pt-11 lg:pl-12 lg:pr-17">
          <div class="inline-flex items-center space-x-4">
            <TransactionOptionsItem v-for="(option,i) in plannedTransactionOptions"
                                    :key="i"
                                    @click="toggleOption(option)"
                                    :active="options[option]"
                                    :option="option"/>
          </div>
          <div v-if="transactionAuthor"
               class="text-sm text-text-ternary leading-10 float-right mr-8 max-w-xs truncate">
            {{ transactionAuthor }}
          </div>
        </div>
        <PlannedTransactionEditForm class="col-span-12"
                                    :template="template"
                                    :options="options"
                                    :submitted="submitted"
                                    @updateTemplate="saveTemplate"
                                    @removeTemplate="removeTemplate"
                                    @cancel="$emit('close')"/>
      </div>
    </template>
  </CustomModal>
</template>

<script>
import CustomModal from "@/components/UI/modals/CustomModal";
import PlannedTransactionEditForm
  from "@/components/common/PlannedTransaction/PlannedTransactionEditModal/PlannedTransactionEditForm";
import TransactionOptionsItem from "@/components/common/Transaction/TransactionOptions/TransactionOptionsItem";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "PlannedTransactionEditModal",
  components: {TransactionOptionsItem, PlannedTransactionEditForm, CustomModal},
  props: {
    template: {
      required: true
    },
    position: {
      type: String,
      default: 'relative'
    }
  },
  data() {
    return {
      submitted: false,
      options: {
        agent: false,
        comment: false,
        tags: false,
      }
    }
  },
  computed: {
    ...mapGetters('space', ['spaceInfo']),
    transactionAuthor() {
      if (!this.spaceInfo.author_enabled) return false;

      const {user} = this.template;
      return user
          ? user.name || user.username || user.email
          : this.$t('authorBankIntegration');
    },
    plannedTransactionOptions() {
      let settings = {
        agent: this.$store.getters['space/spaceUseContractors'],
        comment: true,
        tags: true,
      }
      return Object.keys(settings).filter(option => settings[option]);
    },
  },
  methods: {
    ...mapActions('space/plannedTransactions', ['updatePlannedTransaction', 'removePlannedTransaction']),
    checkTransactionOptions() {
      this.options.agent = !!this.template.contractor_id;
      this.options.comment = !!this.template.comment;
      this.options.tags = !!this.template.tags.length;
    },
    toggleOption(opt) {
      this.options[opt] = !this.options[opt]
    },
    async saveTemplate(data) {
      this.submitted = true;
      try {
        const res = await this.updatePlannedTransaction(data)
        if (res.body.success) {
          this.$toasted.success(this.$t('changesSaved'))
          this.$emit('success')
          this.$emit('close')
        } else {
          this.$toasted.error(this.$t('checkFields'))
        }
      } catch (e) {
        this.$toasted.error(this.$t('errors.response'))
        console.log(e)
      } finally {
        this.submitted = false
      }
    },
    async removeTemplate(id) {
      this.submitted = true;
      try {
        const res = await this.removePlannedTransaction(id)
        if (res.body.success) {
          this.$toasted.success(this.$t('transactionRemoved'))
          this.$emit('success')
          this.$emit('close')
        }
      } catch (e) {
        this.$toasted.error(this.$t('errors.response'))
        console.log(e)
      } finally {
        this.submitted = false
      }
    },
  },
  watch: {
    template: {
      handler(newVal) {
        if (!!newVal) this.checkTransactionOptions()
      }
    }
  },
  i18n: {
    messages: {
      en: {
        editTitle: 'Edit',
        changesSaved: 'Changes saved',
        transactionRemoved: 'Planned transaction removed',
        checkFields: 'Check fields',
        authorBankIntegration: 'Imported from bank'
      },
      ru: {
        editTitle: 'Редактирование',
        changesSaved: 'Изменения сохранены',
        transactionRemoved: 'Запланированная транзакция удалена',
        checkFields: 'Проверьте поля',
        authorBankIntegration: 'Импорт из банка'
      }
    }
  }
}
</script>

<style>
.planned-transaction-edit-modal {
  width: 820px;
}
</style>